export default [
  {
    name: 'email',
    label: 'users.email',
    type: 'email',
    required: true,
  },
];
